import { render } from "./MainBanner.vue?vue&type=template&id=99990a90&scoped=true"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=99990a90&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99990a90"]])

export default __exports__